/* Sweetwater Labs Rose landing interactions. Reinitializes cleanly in Shopify theme editor. */
(() => {
  if (window.__swlRoseLandingLoaded) return;
  window.__swlRoseLandingLoaded = true;
  const q = (root, selector) => root.querySelector(selector);
  const qa = (root, selector) => Array.from(root.querySelectorAll(selector));
  function initializeHero(root) {
    if (root.dataset.slpReady) return;
    root.dataset.slpReady = '1';
    const slides = qa(root, '[data-review-slide]');
    const counter = q(root, '[data-review-counter]');
    const dots = q(root, '[data-review-dots]');
    let current = 0;
    const select = (number) => {
      current = ((number % slides.length) + slides.length) % slides.length;
      slides.forEach((el, i) => el.classList.toggle('is-hidden', i !== current));
      qa(root, '[data-review-dot]').forEach((el, i) => { el.classList.toggle('is-active', i === current); el.setAttribute('aria-current', i === current ? 'true' : 'false'); });
      if (counter) counter.textContent = `${current + 1} / ${slides.length}`;
    };
    if (slides.length < 2) return;
    slides.forEach((_, i) => { const dot = document.createElement('button'); dot.type = 'button'; dot.dataset.reviewDot = '1'; dot.setAttribute('aria-label', `Show testimonial ${i + 1}`); dot.addEventListener('click', () => select(i)); dots?.appendChild(dot); });
    q(root, '[data-review-prev]')?.addEventListener('click', () => select(current - 1));
    q(root, '[data-review-next]')?.addEventListener('click', () => select(current + 1));
    select(0);
  }
  function initializeProduct(root) {
    if (root.dataset.slpReady) return;
    root.dataset.slpReady = '1';
    const thumbs = qa(root, '[data-gallery-thumb]');
    const image = q(root, '.slp-buy__main-img');
    if (thumbs.length < 2) { qa(root, '.slp-buy__photo-arrow').forEach(el => { el.hidden = true; }); }
    let current = 0;
    const show = (i) => {
      if (!thumbs.length || !image) return;
      current = (i + thumbs.length) % thumbs.length;
      const selected = thumbs[current];
      image.removeAttribute('srcset'); image.removeAttribute('sizes');
      image.src = selected.dataset.large;
      image.alt = selected.dataset.alt || '';
      thumbs.forEach((el, j) => { el.classList.toggle('is-active', j === current); el.setAttribute('aria-pressed', j === current ? 'true' : 'false'); });
    };
    thumbs.forEach((el, i) => el.addEventListener('click', () => show(i)));
    q(root, '[data-gallery-prev]')?.addEventListener('click', () => show(current - 1));
    q(root, '[data-gallery-next]')?.addEventListener('click', () => show(current + 1));
    const qty = q(root, '[data-qty-input]');
    q(root, '[data-qty-down]')?.addEventListener('click', () => { if (qty) qty.value = String(Math.max(1, (parseInt(qty.value, 10) || 1) - 1)); });
    q(root, '[data-qty-up]')?.addEventListener('click', () => { if (qty) qty.value = String(Math.max(1, (parseInt(qty.value, 10) || 1) + 1)); });
    const form = q(root, 'form.slp-buy__form');
    const mode = qa(root, 'input[type=radio][name^=slp_purchase_mode_]');
    const hiddenPlan = q(root, '[data-selling-plan]');
    const atc = q(root, '[data-slp-atc]');
    const variant = q(root, '[data-slp-variant]');
    const planJSON = q(root, '[data-slp-variant-plans]');
    let plans = null;
    if (planJSON) { try { plans = JSON.parse(planJSON.textContent); } catch (_) {} }
    const format = (amount) => {
      const currency = plans?.currency || 'USD';
      try { return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style:'currency', currency }).format(amount / 100); }
      catch (_) { return '$' + (amount / 100).toFixed(2); }
    };
    const update = () => {
      mode.forEach((r) => r.closest('label')?.classList.toggle('is-selected', r.checked));
      const selectedVariant = variant?.selectedOptions?.[0];
      const id = Number(variant?.value || q(root, '[data-slp-variant-hidden]')?.value);
      const planForVariant = plans?.variants.find((item) => Number(item.id) === id)?.plans?.[0];
      const oncePrice = selectedVariant ? Number(selectedVariant.dataset.price) : null;
      const subscribed = mode.some((r) => r.value === 'subscribe' && r.checked);
      const subscribeChoice = mode.find((r) => r.value === 'subscribe');
      if (subscribeChoice) {
        subscribeChoice.disabled = !planForVariant;
        subscribeChoice.closest('label').style.display = planForVariant ? '' : 'none';
        if (!planForVariant && subscribed) mode.find(r => r.value === 'once').checked = true;
      }
      const actuallySubscribed = mode.some(r => r.value === 'subscribe' && r.checked) && !!planForVariant;
      if (hiddenPlan) { hiddenPlan.disabled = !actuallySubscribed; hiddenPlan.value = actuallySubscribed ? String(planForVariant.id) : ''; }
      if (oncePrice !== null) {
        const price = actuallySubscribed ? planForVariant.price : oncePrice;
        const priceText = q(root, '[data-price-main]'); if (priceText) priceText.textContent = format(price);
        const onceText = q(root, '[data-price-once]'); if (onceText) onceText.textContent = format(oncePrice);
        const subText = q(root, '[data-price-subscribe]'); if (subText && planForVariant) subText.textContent = format(planForVariant.price);
        const atcPrice = q(root, '[data-price-atc]'); if (atcPrice) atcPrice.textContent = format(price);
      } else if (actuallySubscribed && planForVariant) {
        const priceText = q(root, '[data-price-main]'); if (priceText) priceText.textContent = format(planForVariant.price);
        const atcPrice = q(root, '[data-price-atc]'); if (atcPrice) atcPrice.textContent = format(planForVariant.price);
      } else {
        const onceText = q(root, '[data-price-once]'); const priceText = q(root, '[data-price-main]'); if (onceText && priceText) priceText.textContent = onceText.textContent;
        const atcPrice = q(root, '[data-price-atc]'); if (atcPrice && onceText) atcPrice.textContent = onceText.textContent;
      }
      if (atc) {
        const available = selectedVariant ? selectedVariant.dataset.available === 'true' : !atc.dataset.originalSoldOut;
        atc.disabled = !available;
        if (!available) atc.textContent = 'Sold out';
        else if (!atc.querySelector('[data-price-atc]')) atc.innerHTML = 'Add to cart — <span data-price-atc></span>';
        if (available && q(root, '[data-price-atc]') && q(root, '[data-price-main]')) q(root, '[data-price-atc]').textContent = q(root, '[data-price-main]').textContent;
      }
    };
    if (atc && atc.disabled) atc.dataset.originalSoldOut = '1';
    mode.forEach(el => el.addEventListener('change', update));
    variant?.addEventListener('change', update);
    form?.addEventListener('submit', () => { if (qty) qty.value = String(Math.max(1, parseInt(qty.value, 10) || 1)); });
    update();
  }
  function initializeTabs(root) {
    if (root.dataset.slpReady) return;
    root.dataset.slpReady = '1';
    const tabs = qa(root, '[data-slp-tab]');
    const panels = qa(root, '[data-slp-panel]');
    const choose = (i, focus = false) => {
      tabs.forEach((tab,j)=> {const active=j===i;tab.setAttribute('aria-selected',String(active));tab.tabIndex=active?0:-1;if(active&&focus)tab.focus();});
      panels.forEach((panel,j)=>panel.hidden=j!==i);
    };
    tabs.forEach((el,i)=>{
      el.addEventListener('click',()=>choose(i));
      el.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'||e.key==='Home'||e.key==='End'){e.preventDefault();choose(e.key==='Home'?0:e.key==='End'?tabs.length-1:(i+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length,true);}});
    });
  }
  function initializeReviews(root) {
    if (root.dataset.slpReady) return;
    root.dataset.slpReady = '1';
    const all = qa(root, '[data-review-item]');
    const parent = q(root, '[data-review-items]');
    const pages = q(root, '[data-review-pagination]');
    const filter = q(root, '[data-review-filter]');
    const sort = q(root, '[data-review-sort]');
    const empty = q(root, '[data-reviews-empty]');
    let page = 1;
    const size = 5;
    const refresh = () => {
      let visible = all.filter(el => filter.value==='all' || Number(el.dataset.rating)===Number(filter.value));
      visible.sort((a,b)=>{
        if(sort.value==='highest')return Number(b.dataset.rating)-Number(a.dataset.rating);
        if(sort.value==='lowest')return Number(a.dataset.rating)-Number(b.dataset.rating);
        if(a.dataset.date && b.dataset.date)return b.dataset.date.localeCompare(a.dataset.date);
        return Number(a.dataset.index)-Number(b.dataset.index);
      });
      const total = Math.ceil(visible.length/size);
      page = Math.max(1, Math.min(page, total || 1));
      visible.forEach(el=>parent.appendChild(el));
      all.forEach(el=>el.hidden=true);
      visible.slice((page-1)*size,page*size).forEach(el=>el.hidden=false);
      empty.hidden = visible.length>0;
      pages.innerHTML='';
      if(total<=1)return;
      const make=(label,number,active=false)=>{const b=document.createElement('button');b.type='button';b.textContent=label;b.className=active?'is-current':'';b.setAttribute('aria-label',`Show review page ${number}`);if(active)b.setAttribute('aria-current','page');b.addEventListener('click',()=>{page=number;refresh();});pages.appendChild(b);};
      if(page>1)make('‹',page-1);
      for(let i=1;i<=total;i++)make(String(i),i,i===page);
      if(page<total)make('›',page+1);
    };
    filter?.addEventListener('change',()=>{page=1;refresh()});
    sort?.addEventListener('change',()=>{page=1;refresh()});
    if(filter&&sort&&pages&&parent&&empty)refresh();
  }
  const initialize = (context=document) => {
    const collect=(selector,callback)=>{if(context.matches?.(selector)) callback(context);context.querySelectorAll?.(selector).forEach(callback)};
    collect('[data-slp-hero-reviews]', initializeHero);
    collect('[data-slp-product-section]', initializeProduct);
    collect('[data-slp-tabs]', initializeTabs);
    collect('[data-slp-reviews]', initializeReviews);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize()); else initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
